<div fxLayout="column" fxLayoutAlign="start center" fxFill class="dashboard-container">
  <!-- Welcome Card -->
  <mat-card fxFlex="none" fxLayout="column" fxLayoutGap="16px" class="welcome-card">
    <mat-card-header fxLayout="column" fxLayoutAlign="center start">
      <mat-card-title>Welcome to eudiplo client</mat-card-title>
      <mat-card-subtitle
        >You are successfully authenticated and ready to manage credentials!</mat-card-subtitle
      >
    </mat-card-header>
    <mat-card-content fxLayout="column" fxLayoutGap="16px">
      <p>
        Your authentication is active and the API client is configured. Use the navigation below to
        access different features.
      </p>

      <p></p>
    </mat-card-content>
  </mat-card>

  <!-- Current Configuration -->
  <mat-card fxFlex="none" fxLayout="column" fxLayoutGap="8px" class="config-card">
    <mat-card-header>
      <mat-card-title>Current Configuration</mat-card-title>
      <mat-card-subtitle>Your active connection details</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content fxLayout="column" fxLayoutGap="12px">
      <div fxLayout="column" fxLayoutGap="8px" class="config-item">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>API Base URL</mat-label>
          <input matInput [value]="currentBaseUrl" readonly />
          <button
            mat-icon-button
            matSuffix
            (click)="copyToClipboard(currentBaseUrl, 'API Base URL')"
            matTooltip="Copy to clipboard"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayoutGap="8px" class="config-item">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>OAuth URL</mat-label>
          <input matInput [value]="currentOidcUrl" readonly />
          <button
            mat-icon-button
            matSuffix
            (click)="copyToClipboard(currentOidcUrl, 'OAuth URL')"
            matTooltip="Copy to clipboard"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayoutGap="8px" class="config-item">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Client ID</mat-label>
          <input matInput [value]="currentClientId" readonly />
          <button
            mat-icon-button
            matSuffix
            (click)="copyToClipboard(currentClientId, 'Client ID')"
            matTooltip="Copy to clipboard"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayoutGap="8px" class="config-item">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Client Secret</mat-label>
          <input matInput [value]="currentClientSecret" readonly type="password" />
          <button
            mat-icon-button
            matSuffix
            (click)="copyToClipboard(currentClientSecret, 'Client Secret')"
            matTooltip="Copy to clipboard"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center" class="config-item">
        <span class="config-label">Auto-refresh:</span>
        <mat-chip [class.enabled]="canAutoRefresh" [class.disabled]="!canAutoRefresh">
          {{ canAutoRefresh ? 'Available' : 'Not Available' }}
        </mat-chip>
      </div>
    </mat-card-content>
  </mat-card>
</div>
